<template>
    <div class="avue-contail" :class="{'avue--collapse':isCollapse}" id="watermark">
        <div class="avue-header" v-if="!isbig">
            <!-- 顶部导航栏 -->
            <top ref="top" />
        </div>
        <div class="avue-layout">
            <div class="avue-left">
                <!-- 左侧导航栏 -->
                <sidebar />
            </div>
            <div class="avue-main" :style="{height:isbig?'100%':'calc(100% - 64px)'}" :class="{'isbig':isbig}">
                <!-- 顶部标签卡 -->
                <tags v-if="!isbig" />
                <transition name="fade-scale">
                    <search class="avue-view" v-show="isSearch"></search>
                </transition>
                <!-- 主体视图层 -->
                <!--  style="flex:1;display:flex;flex-direction:column;" -->
                <div id="avue-view" v-show="!isSearch" style="flex:1; overflow: hidden auto;">
                    <div style="display:flex;" :style="{'min-height':isbig?'100%':'calc(100% - 75px)'}" :class="{'large-screen':isbig}">
                        <keep-alive>
                            <router-view class="avue-view" v-if="$route.meta.keepAlive" />
                        </keep-alive>
                        <router-view class="avue-view" v-if="!$route.meta.keepAlive" />
                    </div>
                    <div class="avue-footer-wapper" v-if="!isbig">
                        <div class="footer-text">
                            <div class="mb5">
                                <a target="_blank" href="https://beian.miit.gov.cn/" class="mr5 ml5 f_color">
                                    <img src="/img/bg/footer-icon2.png" class="small-logo">闽ICP备15007253号</a>
                                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010302000233" class="mr5 ml5 f_color"><img src="/img/bg/footer-icon1.png" class="small-logo">闽公安网备35010302000233号</a>
                            <a target="_blank" href="https://myssl.com/seal/detail?domain=xm.vstime.com" class="mr5 ml5 f_color"><img src="/svg/seal.svg" class="small-logo1" title="安全认证"></a>
                            <!-- <a target="_blank" href="https://v.itrust.cn/?safetykeyid=02c3ec78877919a8303fd2102c5bb283" class="mr5 ml5 f_color"><img src="/img/bg/cert.png" class="small-logo2" title="iTrust"></a> -->
                            </div>
                            <div>
                                <span class="mr5 ml5">Copyright © 公益项目信息化管理解决方案提供商</span>
                                <span class="mr5 ml5">版本：V1.0 技术支持：<a target="_blank" href="http://www.vstimevms.com/" >微时刻</a>
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- <footer></footer> -->
                </div>
            </div>
        </div>
        <div class="avue-shade" @click="showCollapse"></div>
        <el-popover placement="left" width="160" v-model="visible" v-if="isbig" trigger="hover">
            <p>是否退出系统</p>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click.native="logout">确定</el-button>
            </div>
            <div class="common-loginout-btn" slot="reference"></div>
        </el-popover>
        <!-- <el-button type="primary" class="common-loginout-btn" v-if="isbig"  @click.native="logout">退出</el-button> -->
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import tags from "./tags";
import search from "./search";
import top from "./top/";
import sidebar from "./sidebar/";
import admin from "@/util/admin";
import { validatenull } from "@/util/validate";
import { calcDate } from "@/util/date.js";
import { getStore } from "@/util/store.js";
import { resetRouter } from '@/router/router'
import { getPublishListDept } from '@/api/order/index'
import { removeWatermark, setWaterMark } from '@/util/water'
export default {
    components: {
        top,
        tags,
        search,
        sidebar
    },
    name: "index",
    provide() {
        return {
            index: this
        };
    },
    data() {
        return {
            visible: false, // 大屏
            //搜索控制
            isSearch: false,
            //刷新token锁
            refreshLock: false,
            //刷新token的时间
            refreshTime: "",
            create: false,
            water: ''
        };
    },
    created() {
        //实时检测刷新token
        this.refreshToken();
        if (this.create) {
            return
        }
        this.create = true;
        getPublishListDept().then(res => {
            let dept = res.data.data.find(v => v.id == this.userInfo.dept_id)
            setWaterMark(dept.deptName+'-'+this.userInfo.nick_name,'公益项目管理系统')
             // this.water = this.watermark({ id: 'watermark', fontSize: '8px', text: dept.deptName+'-'+this.userInfo.nick_name+'-公益项目管理系统' })
        })
    },
    mounted() {
        this.init();
    },
    computed: mapGetters(["isMenu", "isLock", "isCollapse", "website", "menu", "userInfo", "isbig"]),
    props: [],
    methods: {
        showCollapse() {
            this.$store.commit("SET_COLLAPSE");
        },
        // 初始化
        init() {
            this.$store.commit("SET_SCREEN", admin.getScreen());
            window.onresize = () => {
                setTimeout(() => {
                    this.$store.commit("SET_SCREEN", admin.getScreen());
                }, 0);
            };
            this.$store.dispatch("FlowRoutes").then(() => {});
        },
        //打开菜单
        openMenu(item = {}) {
            this.$store.dispatch("GetMenu", item.id).then(data => {
                if (data.length !== 0) {
                    this.$router.$avueRouter.formatRoutes(data, true);
                }
                //当点击顶部菜单后默认打开第一个菜单
                /*if (!this.validatenull(item)) {
                  let itemActive = {},
                    childItemActive = 0;
                  if (item.path) {
                    itemActive = item;
                  } else {
                    if (this.menu[childItemActive].length === 0) {
                      itemActive = this.menu[childItemActive];
                    } else {
                      itemActive = this.menu[childItemActive].children[childItemActive];
                    }
                  }
                  this.$store.commit('SET_MENU_ID', item);
                  this.$router.push({
                    path: this.$router.$avueRouter.getPath({
                      name: (itemActive.label || itemActive.name),
                      src: itemActive.path
                    }, itemActive.meta)
                  });
                }*/

            });
        },
        // 定时检测token
        refreshToken() {
            this.refreshTime = setInterval(() => {
                const token = getStore({
                    name: "token",
                    debug: true
                }) || {};
                const date = calcDate(token.datetime, new Date().getTime());
                if (validatenull(date)) return;
                if (date.seconds >= this.website.tokenTime && !this.refreshLock) {
                    this.refreshLock = true;
                    this.$store
                        .dispatch("refreshToken")
                        .then(() => {
                            this.refreshLock = false;
                        })
                        .catch(() => {
                            this.refreshLock = false;
                        });
                }
            }, 10000);
        },
        logout() {

            this.$store.dispatch("LogOut").then(() => {
                resetRouter();
                this.$router.push({ path: "/login" });
                this.visible = false
            });
        }
    },
    destroyed() {
        removeWatermark()
        // this.water.remove()
    }
};

</script>
<style lang="scss">
@import "@/styles/footer.scss";
    .small-logo1 {
        display: inline-block;
        width: 50px;
        height: 26px;
        margin-right: 5px;
        vertical-align: middle;
    }
    .small-logo2 {
        display: inline-block;
        width: 57px;
        height: 20px;
        margin-right: 5px;
        vertical-align: middle;
    }
</style>
